import { APP_INITIALIZER, NgModule } from '@angular/core'

import { MbNavigationService } from './mb-navigation.service'
import { MbCategoryNavigationModule } from './mb-category-navigation/mb-category-navigation.module'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

@NgModule({
  imports: [
    CommonModule,
    MbCategoryNavigationModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (navigationService: MbNavigationService) => () => navigationService.init(),
      deps: [MbNavigationService],
      multi: true
    }
  ]
})
export class MbNavigationModule {
}
